export default "__VITE_ASSET__hSW_2jXV__"